import React from 'react'
import cn from 'classnames'

import { eventColor, nth } from 'helpers'
import { Inhibitor as Icon } from 'icons'

const Inhibitor = ({ event, blueTeam, redTeam, metadata }) => {
  const { name } = { blueTeam, redTeam }[event.team + 'Team']

  return (
    <div
      className={cn('event', 'inhibitor', eventColor(event, metadata))}
      data-timestamp={event.timestamp}
    >
      <div className="timestamp">{event.timestamp}</div>
      <div className="content">
        <Icon />
        <small className="subtitle">
          {name} take their <b>{nth(event.count)}</b> inhibitor
        </small>
      </div>
    </div>
  )
}

export default Inhibitor
